import axios from "axios";
import store from "../stores/store";
import { showNotification } from "../slices/notificationSlice";
import { getToken } from "../../token/token";

let APINoSubdomain = axios.create({
  baseURL: process.env.REACT_APP_BASEURL_VARIABLE_AUTH,
});

APINoSubdomain.interceptors.request.use(
  (config) => {
    const token = getToken("token") || null;
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

APINoSubdomain.interceptors.response.use(
  (response) => {
    if (
      (response.data.success &&
        window.location.pathname.split("/").indexOf("auth") === -1 &&
        response.config.method === "post") ||
      response.config.method === "put" ||
      response.config.method === "delete"
    ) {
      store.dispatch({
        type: showNotification,
        payload: {
          type: "success",
          message: response?.data?.message || "Somthing went wrong!",
        },
      });
    }

    return response;
  },
  function (error) {
    store.dispatch({
      type: showNotification,
      payload: {
        type: "error",
        message:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Something went wrong! Please check your internet connecton.",
      },
    });

    return Promise.reject(error);
  },
);

export default APINoSubdomain;
